import { Feature, QueryType } from './apollo/graphqlSchema';
import { IconName } from '../components/Icon';
import { appRoutes } from '../path';

interface IQueryTypeConfig {
  display: string;
  url: string;
  icon: IconName;
  isBeta?: boolean;
  requiredFeature?: Feature;
}

export const queryTypeConfigLookup: Record<QueryType, IQueryTypeConfig> = {
  [QueryType.CohortSample]: {
    display: 'Cohort',
    url: appRoutes.cohorts.create,
    icon: 'cohort-inspect',
  },
  [QueryType.Expression]: {
    display: 'Query',
    url: appRoutes.report.query,
    icon: 'chart-line',
  },
  [QueryType.Funnel]: {
    display: 'Funnel',
    url: appRoutes.report.funnel,
    icon: 'funnel',
  },
  [QueryType.Path]: {
    display: 'Path',
    url: appRoutes.report.path,
    icon: 'path',
  },
  [QueryType.Prediction]: {
    display: 'Prediction',
    url: appRoutes.report.prediction,
    icon: 'formula-prediction',
    isBeta: true,
    requiredFeature: Feature.Prediction,
  },
  [QueryType.Retention]: {
    display: 'Retention',
    url: appRoutes.report.retention,
    icon: 'retention',
  },
  [QueryType.DataTable]: {
    display: 'Data Table',
    url: appRoutes.report.dataTable,
    icon: 'table',
  },
  [QueryType.Significance]: {
    display: 'Significance',
    url: appRoutes.report.significance,
    icon: 'significance',
    requiredFeature: Feature.Significance,
  },
};
